(function(angular) {
  'use strict';

  angular.module('linagora.esn.contact')
    .component('contactAddressbookSharedConfiguration', {
      template: require('./addressbook-shared-configuration.pug')
    });
})(angular);
